{
  "version": 1,
  "asset_id": "66348838-9a1f-45ef-81d1-e94a3c619088",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/66348838-9a1f-45ef-81d1-e94a3c619088/egg-dragon.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/66348838-9a1f-45ef-81d1-e94a3c619088/egg-dragon.webp",
  "original_filename": "egg-dragon.webp",
  "size": 7446,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:54:06Z"
}
